import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useRouteError } from 'react-router-dom';
// @mui
import { Button, Container, Typography } from '@mui/material';
// components
import { MotionContainer, varBounce } from '../components/animate';
// assets
import { SeverErrorIllustration } from '../assets/illustrations';
import { PATHS } from 'src/routes/paths';
import { useSlugContext } from 'src/hooks/slugProvider';
import NotFoundImage from 'src/assets/404/EN_CONSTRUCCIÓN.svg';
import { useLocales } from 'src/locales';

// ----------------------------------------------------------------------

export default function ErrorPage() {
  const { slug_id: slug } = useSlugContext();
  const mockedSlug = slug;
  const { translate: t } = useLocales();

  let error = useRouteError();
  return (
    <>
      <Helmet>
        <title> Error | Ambigú</title>
      </Helmet>
      <Container maxWidth="lg">
        <MotionContainer
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <m.div variants={varBounce().in}>
            <Typography variant="h3" paragraph>
              Error
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <Typography>There was an error, please try again later.</Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <Typography sx={{ color: 'text.secondary' }}>
              {(error as any)?.message ?? 'Unknown error'}
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <img
              src={NotFoundImage}
              style={{ marginBottom: '5rem' }}
              width={200}
              alt={t('notFound.heading')}
            />
          </m.div>

          <Button
            to={PATHS.home.view(mockedSlug)}
            component={RouterLink}
            size="large"
            variant="contained"
          >
            Go to Home
          </Button>
        </MotionContainer>
      </Container>
    </>
  );
}
